const tabs = document.querySelectorAll('.js-image-slider-tab');
const items = document.querySelectorAll('.js-image-slider-item');

if ( tabs.length > 0 || items.length > 0 ) {
    tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
        const itemIndex = tab.getAttribute('data-item');

        tabs.forEach((t) => {
        t.classList.remove('active-tab');
        });

        tab.classList.add('active-tab');

        items.forEach((item) => {
        item.classList.remove('active-item');
        });

        items.forEach((item) => {
        if (item.getAttribute('data-item') === itemIndex) {
            item.classList.add('active-item');
        }
        });
    });
    });

    tabs[0].classList.add('active-tab');
    items[0].classList.add('active-item');
}